import { message, Modal } from 'antd';

const { confirm: antdConfirm } = Modal;
message.config({
  maxCount:1
})
const alert = (msg, duration) => {
  return message.info(msg, duration);
};

const success = (msg, duration) => {
  return message.success(msg, duration);
};

const warning = (msg, duration) => {
  return message.warning(msg, duration);
};

const error = (msg, duration=3) => {
  return message.error(msg, duration);
};

const loading = msg => {
  return message.loading(msg, 0);
};

const confirm = (msg, onOkFunc, onCancelFunc) => {
  antdConfirm({
    title: '系统提示信息',
    content: msg,
    okText: '确认',
    okType: 'primary',
    cancelText: '取消',
    onOk() {
      onOkFunc && onOkFunc();
    },
    onCancel() {
      onCancelFunc && onCancelFunc();
    },
  });
};

export default {
  alert,
  success,
  warning,
  error,
  loading,
  confirm,
};
